import React, { useState } from 'react';
import { UserPlus } from 'lucide-react';
import { toast } from 'sonner';
import { api, errText } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger,
} from '@/components/ui/dialog';

const EMPTY = { pastor: '', church: '', email: '', phone: '', city: '' };
const FIELDS = [['pastor', 'Pastor'], ['church', 'Iglesia'], ['email', 'Correo'], ['phone', 'WhatsApp'], ['city', 'Ciudad']];

export function AddContactDialog({ campaignId, onDone }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);

  const submit = async () => {
    try {
      await api.post(`/campaigns/${campaignId}/contacts`, form);
      toast.success('Congregación agregada');
      setForm(EMPTY);
      setOpen(false);
      onDone();
    } catch (e) {
      toast.error(errText(e, 'No se pudo agregar'));
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" data-testid="contacts-add-button"><UserPlus className="h-4 w-4 mr-1" />Agregar</Button>
      </DialogTrigger>
      <DialogContent data-testid="contacts-add-dialog">
        <DialogHeader>
          <DialogTitle>Agregar congregación</DialogTitle>
          <DialogDescription>Necesita al menos un correo válido o un WhatsApp.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          {FIELDS.map(([k, label]) => (
            <div key={k} className="space-y-1">
              <Label htmlFor={`contact-${k}`}>{label}</Label>
              <Input id={`contact-${k}`} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`contacts-add-${k}`} />
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button onClick={submit} disabled={!form.email && !form.phone} data-testid="contacts-add-submit">Agregar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
